<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <div class="text-center md:mb-10 lg:mb-20 mb-4">
        <h1>{{ $t("city.titlePrefix") }} {{ cityData.title }}</h1>
        <div class="h1-subtitle leading-8 text-center mx-7 md:mx-0">
          {{ cityData.h1_title }}
        </div>
      </div>
      <NuxtLayout name="center" class="w-full">
        <div class="flex md:flex-row flex-col mt-12 md:my-12 lg:my-18">
          <ClinicContentLeft>
            <ClinicBuildingBlock></ClinicBuildingBlock>
          </ClinicContentLeft>

          <ClinicContentRight class="md:mt-[5.5rem]">
            <div class="intro-text mb-4">{{ cityData.intro_text }}</div>
            <div class="condition-content" v-html="cityData.text_before_map ?? ''"></div>
          </ClinicContentRight>
        </div>
      </NuxtLayout>
      <NuxtLayout name="center" class="w-full mt-4 md:mt-0">
        <h2 class="text-center mx-auto mb-8">
          {{ $t("city.selectClinicAndChooseTest") }}
        </h2>
      </NuxtLayout>
      <div class="bg-secondary-lighter md:mt-0 mt-4 md:relative md:overflow-hidden">
        <div class="flex md:flex-row flex-col md:max-w-7xl md:mx-auto md:h-[844px]">
          <div class="md:w-[40%] pt-8 mb-12 md:mb-0">
            <ClinicMapList
              :isCityPage="true"
              :isEveryWhereServiceActive="cityData.everywhere_active"
              @onTabClick="(data) => (showMap = data)"
              :isMobile="isMobile"
              :showTabView="true"
              :clinicLists="clinicLists"
              :clinicSlug="clinicSlug"
              :listHeight="isNurseStationServiceEnabled ? 'h-[744px] md:h-[680px]' : 'md:h-[744px]'"
              @clinicTypeChanged="(val) => (clinicTypeFilter = val)"
            ></ClinicMapList>
          </div>
          <ClientOnly>
            <div class="md:absolute md:w-[60%] map-container md:right-0">
              <ClinicGoogleMap
                class="md:ml-8 large-desktop:ml-15 2xl:ml-20"
                :isMobile="isMobile"
                :showGoogleMap="showMap"
                @getClinicsList="setClinicLists"
                :citySlug="cityData.slug"
                :cityTitle="cityData.title"
                :range="cityData.default_range"
                :zoom="cityData.default_zoom"
                :clinicTypeFilter="clinicTypeFilter"
                :isCityPage="true"
              ></ClinicGoogleMap>
            </div>
          </ClientOnly>
        </div>
      </div>
      <ClinicDetail
        :clinicData="cityData.text_after_map"
        :bgWhite="true"
        class="mb-10 md:mt-6 lg:mt-10"
        styleContentClass=""
      ></ClinicDetail>
      <div class="bg-secondary-lighter mb-6 md:mb-10 lg:mb-20">
        <div class="max-w-md md:mx-auto md:max-w-6xl justify-center pt-12 pb-8 px-4 lg:px-0">
          <CommonHowItWorks title-position="left" />
        </div>
      </div>
      <div class="bg-white my-6 md:my-10 lg:my-20" v-if="cityData.display_supplemental_content">
        <NuxtLayout name="center">
          <div class="flex md:flex-row flex-col mb-12 md:my-12 lg:my-18">
            <ClinicContentLeft :changeOrder="false">
              <h2 class="text-left text-[27px] leading-6 mb-6">
                {{ cityData.supplemental_title }}
              </h2>
              <div class="text-space-cadet leading-7 space-y-5">
                <div v-html="cityData.supplemental_introduction"></div>
                <div>
                  {{ $t("chat.callUs") }}
                  <NuxtLink
                    :to="
                      'tel:' +
                      globalStore.sitePrimaryPhoneNumber.country_code +
                      globalStore.sitePrimaryPhoneNumber.call_to_action_number
                    "
                    class="text-secondary underline"
                  >
                    {{ globalStore.sitePrimaryPhoneNumber.display_number }}
                  </NuxtLink>
                </div>
                <div>
                  <NuxtLink to="#" class="text-secondary underline">
                    {{ $t("chat.button") }}
                  </NuxtLink>
                </div>
              </div>
            </ClinicContentLeft>
            <ClinicContentRight :changeOrder="false" class="clinicDetailContent">
              <CommonAccordian
                class="w-full md:my-0"
                :dataLists="cityData.accordion_formatted_information"
                :isClinicDetail="true"
              ></CommonAccordian>
            </ClinicContentRight>
          </div>
        </NuxtLayout>
      </div>
      <ClinicCTABlock imgSrc="USPs_graphic_03_1" :getStarted="true" class="mt-12 md:mt-0"></ClinicCTABlock>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from "@/stores/global";
import { useMapStore } from "@/stores/map";
import { useProductStore } from "~/stores/filter";

const props = defineProps({
  cityData: {
    type: Object,
    required: true,
  },
});

const route = useRoute();
const isMobile = useScreenSize("sm");
const showClose = ref(false);
const showMap = ref(false);
const clinicTypeFilter = ref(["clinic", "nurse-station"]);
const mapStore = useMapStore();
const globalStore = useGlobalStore();
const clinicLists = ref([]);
const mapSearchText = ref("");
const productStore = useProductStore();
const filterOptions = ref({});
const breadcrumbs = ref();

filterOptions.value = await useFilterOptions();
productStore.setFilterOptions(filterOptions.value);

const clinicSlug = computed(() => route.query.slug);
const isNurseStationServiceEnabled = toRef(globalStore.siteNurseStationServiceEnabled);

// Generate breadcrumbs
breadcrumbs.value = await getBreadcrumbs("city", props.cityData);

function setClinicLists(data) {
  clinicLists.value = data;
}
</script>

<style scoped></style>
